"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorBoundary = void 0;
const React = __importStar(require("react"));
const logging_1 = require("../../../logging");
const ContentPage_1 = require("../../pages/base/ContentPage");
const HorizontalRule_1 = require("../horizontal-rule/HorizontalRule");
const Section_1 = require("../section/Section");
const Paragraph_1 = require("../paragraph/Paragraph");
const Button_1 = require("../button/Button");
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    componentDidCatch(error, info) {
        logging_1.logging.error(error, info);
        this.setState({ hasError: true });
    }
    render() {
        return this.state.hasError ? React.createElement(ContentPage_1.ContentPage, { title: 'An error occurred', noBackLink: true },
            React.createElement(Section_1.Section, { heading: "Something went wrong" },
                React.createElement(HorizontalRule_1.HorizontalRule, null),
                React.createElement(Paragraph_1.Paragraph, null, "There was a problem loading this page."),
                React.createElement(Paragraph_1.Paragraph, null, "If the problem continues, please contact customer support who will be happy to help you."),
                React.createElement(Button_1.Button, { onClick: () => window.location.replace(this.props.recoveryUrl) }, "Return to the task dashboard"))) : this.props.children;
    }
}
exports.ErrorBoundary = ErrorBoundary;
//# sourceMappingURL=ErrorBoundary.js.map